import { recordTestInstance } from '../axios';

const getActiveVehicleNumbers = (vehNo: string, customerId: string, pagination = null, filters = { active: true }) =>
  recordTestInstance.post('/vehicle-numbers', { customerId, vehNo, pagination, filters });

export default getActiveVehicleNumbers;
